import { Pipe, PipeTransform } from '@angular/core';
import { INVOICE_STATUS_LABEL, InvoiceStatus } from '~gc/domains/invoices';

@Pipe({ name: 'invoiceStatusLabel' })
export class InvoiceStatusLabelPipe implements PipeTransform {
  transform(status: string, reportsProgress: boolean = false, payoutResentOn?: string | null): string {
    // TT-229: a failed payout that was resent reads "Resent" while it processes, so the company and the
    // installer see Payout failed, then Resent, then Paid.
    if (status === InvoiceStatus.PaymentProcessing && payoutResentOn) {
      return 'Resent';
    }
    return status === InvoiceStatus.Paid && reportsProgress ? 'Approved' : INVOICE_STATUS_LABEL[status];
  }
}
